import BrandHeroBlock from '@/blocks/BrandHeroBlock';
import BreadcrumbsBlock from '@/blocks/BreadcrumbsBlock';
import TextImageAsideBlock from '@/blocks/TextImageAsideBlock';
import CheckList from '@/components/CheckList';
import { MEDIA_URL, REVALIDATE_TIME_IN_SEC } from '@/constants/env';
import { pages } from '@/content';
import FullWidthLayout from '@/layouts/FullWidthLayout';
import graphql from '@/lib/graphql';
import mainLayout from '@/graphql/queries/mainLayout';
import page from '@/graphql/queries/page';

export default function EngineeringAndDesignPage({ mainLayout, page }) {
  const attributes = page?.attributes || {};
  const contentSection = attributes.contentSection || [];
  const metaData = attributes.metaData || {};
  return (
    <FullWidthLayout mainLayout={mainLayout} metaData={metaData}>
      {contentSection[0]?.heroImage?.data?.attributes?.url ? (
        <BrandHeroBlock
          image={MEDIA_URL.concat(contentSection[0].heroImage.data.attributes.url)}
          title={contentSection[0].heroTitle}
        />
      ) : null}
      <BreadcrumbsBlock items={[pages.home, pages.engineering, pages.engineeringAndDesign]} />
      {/* {items.map(({ title, image, items }, i) => (
        <TextImageAsideBlock
          key={i}
          image={image}
          imageDirection={i % 2 ? 'right' : 'left'}
          title={<h2 className="text-2xl font-semibold text-primary-500 md:text-3xl">{title}</h2>}
        >
          <CheckList className="text-lg" items={items} />
        </TextImageAsideBlock>
      ))} */}
      {contentSection[1]?.textImageADarkImage?.data?.attributes?.url ? (
        <TextImageAsideBlock
          image={MEDIA_URL.concat(contentSection[1].textImageADarkImage.data.attributes.url)}
          imageDirection={'left'}
          title={
            <h2 className="text-2xl font-semibold text-primary-500 md:text-3xl">
              {contentSection[1].textImageADarkTitle}
            </h2>
          }
        >
          <CheckList className="text-lg" items={contentSection[1].list || []} />
        </TextImageAsideBlock>
      ) : null}
      {contentSection[2]?.textImageADarkImage?.data?.attributes?.url ? (
        <TextImageAsideBlock
          image={MEDIA_URL.concat(contentSection[2].textImageADarkImage.data.attributes.url)}
          imageDirection={'right'}
          title={
            <h2 className="text-2xl font-semibold text-primary-500 md:text-3xl">
              {contentSection[2].textImageADarkTitle}
            </h2>
          }
        >
          <CheckList className="text-lg" items={contentSection[2].list || []} />
        </TextImageAsideBlock>
      ) : null}
      {contentSection[3]?.textImageADarkImage?.data?.attributes?.url ? (
        <TextImageAsideBlock
          image={MEDIA_URL.concat(contentSection[3].textImageADarkImage.data.attributes.url)}
          imageDirection={'left'}
          title={
            <h2 className="text-2xl font-semibold text-primary-500 md:text-3xl">
              {contentSection[3].textImageADarkTitle}
            </h2>
          }
        >
          <CheckList className="text-lg" items={contentSection[3].list || []} />
        </TextImageAsideBlock>
      ) : null}
      {contentSection[4]?.textImageADarkImage?.data?.attributes?.url ? (
        <TextImageAsideBlock
          image={MEDIA_URL.concat(contentSection[4].textImageADarkImage.data.attributes.url)}
          imageDirection={'right'}
          title={
            <h2 className="text-2xl font-semibold text-primary-500 md:text-3xl">
              {contentSection[4].textImageADarkTitle}
            </h2>
          }
        >
          <CheckList className="text-lg" items={contentSection[4].list || []} />
        </TextImageAsideBlock>
      ) : null}
    </FullWidthLayout>
  );
}

export async function getStaticProps() {
  const { data: mainLayoutData } = await graphql(mainLayout);

  const { data: pageData } = await graphql(page, { slug: 'engineering-and-design' });

  return {
    props: {
      mainLayout: mainLayoutData.mainLayout.data,
      page: pageData.pages.data[0],
    },
    revalidate: parseInt(REVALIDATE_TIME_IN_SEC), // In seconds
  };
}
